import { get } from 'lodash';
import { FEATURE_FLAG, hasCapability, isSuperAdmin, isContentManager } from 'itrvl-types';

export { hasCapability, isSuperAdmin, isContentManager };

export const isAgencyAdmin = user => isSuperAdmin(user) || hasCapability(user, 'agencyadmin');
export const isTeamAgent = user => isAgencyAdmin(user) || get(user, 'agency.admins', []).includes(get(user, 'userId', ''));
// itrvl internal admin role; gates itrvl-staff-only tools like the email control plane.
export const isItrvlAdmin = user => hasCapability(user, 'itrvladmin');
export const isRetail = user => isSuperAdmin(user) || hasCapability(user, 'retail');
export const isMasqueradeFromSuperAdmin = user => !!get(user, 'masqueradeFromSuperAdmin');
export const isBasic = user => {
  return (
    !isRetail(user) || isSuperAdmin(user) || isTeamAgent(user) || hasCapability(user, 'contentmanager') || isMasqueradeFromSuperAdmin(user)
  );
};
export const isRetailOnly = user => isRetail(user) && !isBasic(user);

// AI Chat is visible to super admins, to agents granted the per-agent 'aichat' capability,
// and to everyone in an agency with the allowChat flag enabled.
export const isAiChatEnabled = (user, customizations) =>
  isSuperAdmin(user) || hasCapability(user, 'aichat') || get(customizations, FEATURE_FLAG.ALLOW_CHAT) === true;

export const isAuthenticated = user => {
  return !!user;
};

// Content Manager is viewable read-only by every authenticated agent except a pure Edge agent.
// Edit access (isContentManager) is a subset of this view access.
export const canViewContentManager = user => isAuthenticated(user) && !isRetailOnly(user);
